/**
 * File globals-slick.js.
 * Contains global functions for use across multiple slick sliders
 */

function slickAnimate(slider) {
  const nextArrow = slider.parent().find('.next-arrow');
  const prevArrow = slider.parent().find('.prev-arrow');

  function wipeFadeClasses() {
    slider.removeClass('slider--fade-left');
    slider.removeClass('slider--fade-right');
  }

  function setFadeDirection(direction) {
    wipeFadeClasses();
    slider.addClass('slider--fade-' + direction);
  }

  nextArrow.click(function() {
    setFadeDirection('left');
  });

  prevArrow.click(function() {
    setFadeDirection('right');
  });

  // slick event
  slider.on('swipe', function(event, slick, direction) {
    setFadeDirection(direction);
  });
}
